function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import moment from 'moment';
import { deleteEntryOfType } from 'shared/helper/redux-cache';
import { provideAdaUserData } from 'researcher/helpers/ada';
import { recordUser, recordNumberOfOrders } from 'researcher/helpers/gtm';
import { storage } from 'shared/helper/storage';
import { convertUserDataToUserUpdateRequest, convertUserDetailsToJson } from 'shared/view/user-conversion-service';
import * as c from './constants';
export var loadUser = function loadUser(user) {
  return function (dispatch) {
    recordUser(user);
    provideAdaUserData(user);
    if (user && user.identity) {
      dispatch(loadNumberOfOrders(user.identity));
    }
    return dispatch(_objectSpread(_objectSpread({
      type: c.USER_LOADED
    }, user), {}, {
      cacheUntil: moment().add(10, 'm')
    }));
  };
};
export var finishLoadingUser = function finishLoadingUser() {
  return {
    type: c.USER_LOADING_FINISHED
  };
};
export var invalidateUser = function invalidateUser() {
  deleteEntryOfType(c.USER_LOADED);
  return {
    type: c.USER_INVALIDATED
  };
};
export var logout = function logout() {
  return function () {
    return deleteEntryOfType(c.USER_LOADED);
  };
};
export var loadNumberOfOrders = function loadNumberOfOrders(userIdentity) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    var cachedNumberOfOrders = storage.get('numberOfOrders');
    if (useCache && cachedNumberOfOrders) {
      recordNumberOfOrders(cachedNumberOfOrders);
      return dispatch({
        type: c.USER_ORDER_COUNT_LOADED,
        numberOfOrders: cachedNumberOfOrders
      });
    }
    return dispatch(application.get("/api/users/".concat(userIdentity, "/order-count"))).then(function (_ref2) {
      var rawNumberOfOrders = _ref2.numberOfOrders;
      var numberOfOrders = parseInt(rawNumberOfOrders, 10);
      storage.set('numberOfOrders', numberOfOrders);
      recordNumberOfOrders(numberOfOrders);
      return dispatch({
        type: c.USER_ORDER_COUNT_LOADED,
        numberOfOrders: numberOfOrders
      });
    });
  };
};
var formatRawTransactionDate = function formatRawTransactionDate(items, formatDate) {
  return items.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      formattedDate: formatDate(moment(item.transactionDate)),
      formattedExpirationDate: item.expirationDate ? formatDate(moment(item.expirationDate)) : ''
    });
  });
};
var formatTransactionDate = function formatTransactionDate(items) {
  return formatRawTransactionDate(items, function (date) {
    return date.format('MMMM DD, YYYY');
  });
};
var formatUTCTransactionDate = function formatUTCTransactionDate(items) {
  return formatRawTransactionDate(items, function (date) {
    return date.utc().format('MMMM DD, YYYY');
  });
};
export var loadUserInvoicingData = function loadUserInvoicingData() {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    // We can't load invoicing data unless we have a user
    if (!getState().user.loggedIn) {
      return null;
    }
    return dispatch(application.get('api/invoice/load')).then(function (_ref4) {
      var pendingPayments = _ref4.pendingPayments,
        rawInvoices = _ref4.invoices,
        rawUnpaidInvoices = _ref4.unpaidInvoices,
        rawCredits = _ref4.credits,
        currency = _ref4.currency,
        paymentMethods = _ref4.paymentMethods,
        usdCredits = _ref4.usdCredits,
        rawPrepayments = _ref4.prepayments,
        voucherAvailable = _ref4.voucherAvailable;
      var invoices = formatTransactionDate(rawInvoices);
      var prepayments = formatUTCTransactionDate(rawPrepayments);
      var unpaidInvoices = formatTransactionDate(rawUnpaidInvoices);
      var credits = formatUTCTransactionDate(rawCredits);
      return dispatch({
        type: c.USER_INVOICING_DATA_LOADED,
        credits: credits,
        currency: currency,
        invoices: invoices,
        paymentMethods: paymentMethods,
        unpaidInvoices: _.keyBy(unpaidInvoices, 'invoiceNumber'),
        usdCredits: usdCredits,
        pendingPayments: _.keyBy(pendingPayments, 'receiptCode'),
        prepayments: prepayments,
        voucherAvailable: voucherAvailable
      });
    });
  };
};
export var addPreferredGroup = function addPreferredGroup(userIdentity, groupCode) {
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    return dispatch(application.post("/api/users/".concat(userIdentity, "/preferred-group"), {
      groupCode: groupCode
    })).then(function (json) {
      dispatch(application.addMessage({
        type: json.error ? 'error' : 'success',
        message: json.error ? 'preferred-group-join-generic-error' : 'You have been associated with the group code you entered.'
      }));
      if (json.preferredGroup) {
        dispatch({
          type: c.USER_PREFERRED_GROUP_ADDED,
          preferredGroup: json.preferredGroup
        });
      }
      return json;
    });
  };
};
export var removePreferredGroup = function removePreferredGroup(userIdentity, groupCode) {
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    return dispatch(application.del("/api/users/".concat(userIdentity, "/preferred-group"))).then(function (json) {
      dispatch(application.addMessage({
        type: json.error ? 'error' : 'success',
        message: json.error ? 'generic error message' : 'preferred-group-leave-success',
        params: {
          groupCode: groupCode
        }
      }));
      if (!json.preferredGroup) {
        dispatch({
          type: c.USER_PREFERRED_GROUP_REMOVED
        });
      }
      return json;
    });
  };
};
export var updateAddress = function updateAddress(address) {
  return function (dispatch, getState, _ref7) {
    var application = _ref7.application;
    return dispatch(application.put("/api/account/addresses/".concat(address.id), {
      address: address
    })).then(function (address) {
      dispatch({
        type: c.ADDRESS_UPDATED,
        address: address
      });
    });
  };
};
export var deleteAddress = function deleteAddress(addressId) {
  return function (dispatch, getState, _ref8) {
    var application = _ref8.application;
    dispatch({
      type: c.ADDRESS_DELETED,
      addressId: addressId
    });
    return dispatch(application.del("/api/account/addresses/".concat(addressId)));
  };
};
export var hideCheckSpamMessageBanner = function hideCheckSpamMessageBanner(identity) {
  return function (dispatch, getState, _ref9) {
    var application = _ref9.application;
    return dispatch(application.put("/api/users/".concat(identity, "/hide-check-spam-message"))).then(function (_ref10) {
      var user = _ref10.user;
      return dispatch(updateUser(user));
    });
  };
};
export var updateUser = function updateUser(user) {
  return _objectSpread({
    type: c.USER_UPDATED
  }, user);
};
export var onFapiaoCancelled = function onFapiaoCancelled(fapiao) {
  return {
    type: c.FAPIAO_CANCELLED,
    retainerInvoiceNumber: fapiao.receiptCode,
    fapiao: fapiao
  };
};
export var userAcceptWfoeToS = function userAcceptWfoeToS(userIdentity) {
  return function (dispatch, getState, _ref11) {
    var application = _ref11.application;
    dispatch({
      type: c.USER_ACCEPTED_WFOE_TOS_REQUESTED
    });
    return dispatch(application.put("/api/users/".concat(userIdentity, "/wfoe-tos-accepted"))).then(function () {
      dispatch({
        type: c.USER_ACCEPTED_WFOE_TOS
      });
    });
  };
};
export var userWfoeOptIn = function userWfoeOptIn(userIdentity) {
  return function (dispatch, getState, _ref12) {
    var application = _ref12.application;
    return dispatch(application.put("/api/users/".concat(userIdentity, "/wfoe-opt-in"))).then(function () {
      dispatch(application.addMessage({
        type: 'success',
        message: 'wfoe-migration-notice-optin-success'
      }));
      dispatch({
        type: c.USER_WFOE_OPT_IN
      });
    });
  };
};
export var userSkipWfoeNotice = function userSkipWfoeNotice() {
  return function (dispatch) {
    dispatch({
      type: c.USER_SKIPPED_WFOE_NOTICE
    });
  };
};
export var fetchUserRewardPoints = function fetchUserRewardPoints(_ref13) {
  var externalId = _ref13.externalId,
    userIdentity = _ref13.userIdentity;
  return function (dispatch, getState, _ref14) {
    var application = _ref14.application;
    return dispatch(application.get("/api/users/".concat(userIdentity, "/reward-points?externalId=").concat(externalId))).then(function (json) {
      dispatch({
        totalRewardPoints: json.totalRewardPoints,
        type: c.USER_REWARD_POINTS_UPDATED
      });
      return json.updated;
    });
  };
};
export var updateUserCurrencySelection = function updateUserCurrencySelection(currencyIso) {
  return function (dispatch, getState, _ref15) {
    var application = _ref15.application;
    var _getState = getState(),
      user = _getState.user;
    return dispatch(application.put("/api/account/".concat(user.identity, "/update-details"), convertUserDataToUserUpdateRequest(user, currencyIso))).then(function (json) {
      var _json$error$error, _json$error;
      var error = (_json$error$error = (_json$error = json.error) === null || _json$error === void 0 ? void 0 : _json$error.error) !== null && _json$error$error !== void 0 ? _json$error$error : '';
      if (error) {
        return dispatch(application.addMessage({
          type: 'error',
          message: 'generic-touchup-error'
        }));
      }
      dispatch(_objectSpread({
        type: c.USER_UPDATED
      }, convertUserDetailsToJson(json.userDetails)));
      return dispatch(application.addMessage({
        type: 'success',
        message: "save-currency-success"
      }));
    });
  };
};